export const generateTimeSlots = (serviceType) => {
    const slots = [];
    let startHour, startMin, endHour, endMin;

    if (serviceType === 'Cosmetic Gynaecology') {
        // 4:00 PM to 7:00 PM
        startHour = 16; startMin = 0;
        endHour = 19; endMin = 0;
    } else if (serviceType === 'Cosmetic Dermatology') {
        // 3:30 PM to 7:30 PM
        startHour = 15; startMin = 30;
        endHour = 19; endMin = 30;
    } else {
        return [];
    }

    let currentHour = startHour;
    let currentMin = startMin;

    while (currentHour < endHour || (currentHour === endHour && currentMin < endMin)) {
        const startTime = `${currentHour.toString().padStart(2, '0')}:${currentMin.toString().padStart(2, '0')}`;

        // Add 15 minutes for end time
        let endSlotMin = currentMin + 15;
        let endSlotHour = currentHour;
        if (endSlotMin >= 60) {
            endSlotMin -= 60;
            endSlotHour += 1;
        }
        const endTime = `${endSlotHour.toString().padStart(2, '0')}:${endSlotMin.toString().padStart(2, '0')}`;

        // Format for display (12-hour format)
        const formatTime = (hour, min) => {
            const period = hour >= 12 ? 'PM' : 'AM';
            const displayHour = hour > 12 ? hour - 12 : (hour === 0 ? 12 : hour);
            return `${displayHour}:${min.toString().padStart(2, '0')} ${period}`;
        };

        const displayStart = formatTime(currentHour, currentMin);
        const displayEnd = formatTime(endSlotHour, endSlotMin);

        slots.push({
            value: `${startTime}-${endTime}`,
            display: `${displayStart} to ${displayEnd}`
        });

        // Move to next slot (add 20 minutes from start time)
        currentMin += 20;
        if (currentMin >= 60) {
            currentMin -= 60;
            currentHour += 1;
        }
    }

    return slots;
};

export const isSlotBooked = (date, serviceType, timeSlot, bookedSlots = {}) => {
    if (!date || !serviceType || !timeSlot) return false;
    const key = `${date}_${serviceType}_${timeSlot}`;
    return bookedSlots?.[key] === true;
};
